
import { useFadeIn } from '../../../hooks/useFadeIn';

export default function DoctorMessage() {
  const img = useFadeIn({ direction: 'left' });
  const text = useFadeIn({ direction: 'up', delay: 200 });

  return (
    <section className="py-32 md:py-40 px-6 bg-gray-50">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-[auto_1fr] md:grid-cols-5 gap-6 md:gap-12 items-start">
          <div ref={img.ref} style={img.style} className="flex justify-center md:col-span-2">
            <div className="w-24 h-24 md:w-48 md:h-48 overflow-hidden rounded-lg flex-shrink-0">
              <img
                src="https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/e76709526e5a74de30833ffcc41ae720.jpeg"
                alt="医師"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          
          <div ref={text.ref} style={text.style} className="md:col-span-3 space-y-8">
            <div className="space-y-6 text-gray-700 text-sm md:text-base font-light leading-loose">
              <p>
                私たちは、皆様に「今すぐ決めてください」とは言いません。
              </p>
              <p>
                矯正治療は、長い時間をかけて向き合うものです。<br />
                だからこそ、納得のいく判断をしていただきたいと考えています。
              </p>
              <p>
                ご自身のペースで、ゆっくりと考えてください。<br />
                私たちは、その時間を大切にします。
              </p>
            </div>
            
            <div className="pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-600 font-light">
                医療法人mirai さいわいデンタルクリニック<br />
                理事長 谷口正昭
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
